import React from 'react';

export const REPORT_RENDER_MESSAGE = 'We could not display part of this report. No report information was uploaded or saved. Clear the report and try again.';

export default class TrainingResultsBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    // Never retain the exception, component stack, or any report-derived text.
    return { failed: true };
  }

  render() {
    if (this.state.failed) return <section className="training-error" role="alert">
      <h2>Report preview unavailable</h2>
      <p>{this.props.sample ? 'We could not display this fictional sample. No report was uploaded or processed. Return to the introduction and try again.' : REPORT_RENDER_MESSAGE}</p>
      <button className="training-button training-secondary" onClick={this.props.onClear}>{this.props.sample ? 'Return to introduction' : 'Clear report'}</button>
    </section>;
    return this.props.children;
  }
}

// React 19 logs caught exceptions at the root even when a boundary renders a
// fallback. Suppress only this report boundary's raw exceptions; preserve the
// default production logging behavior for all unrelated application boundaries.
export function reportCaughtError(error, info) {
  if (info?.errorBoundary instanceof TrainingResultsBoundary) return;
  console.error(error);
}
